import { doc, updateDoc } from 'firebase/firestore'
import { MODIFICA_STATO_SPINNER } from './MODIFICA_STATO_SPINNER'

export const MODIFICA_STATO_RICHIESTA_CONTATTO = async (id, stato) => {
    MODIFICA_STATO_SPINNER(true)
    await updateDoc(doc(db, 'richiesteContatto', id), {letto : stato})
    MODIFICA_STATO_SPINNER(false)
    return
}
